// automatically generated by the FlatBuffers compiler, do not modify

export enum CompressionType{
  LZ4_FRAME = 0,
  ZSTD = 1
}

